import React from 'react'
import { Spin } from 'antd'

export const Spinner = (props: any) => {
  return <Spin size="large" {...props}></Spin>
}
